import styled from 'styled-components';
import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';

import { ReactComponent as Logo } from 'asserts/icons/3D_Logo.svg';

const Update = () => {
  return (
    <Wrappaer>
      <ImageWrapper>
        <Logo />
        <ContentsWrapper>
          <Title>서비스점검</Title>
          <p className="date">2024.12.16 PM 09:00 ~ 2024.12.17 AM 00:00 (3시간)</p>
          <p>
            안정적인 서비스 이용을 위하여 exbody 프로그램 점검이 실시 됩니다.
            <br /> 점검 시간 동안 프로그램 사용이 어렵습니다.
          </p>
          <p>exbody 프로그램을 이용해주시는 모든 고객님들께 감사드립니다.</p>
        </ContentsWrapper>
      </ImageWrapper>
    </Wrappaer>
  );
};

export default Update;

const Wrappaer = styled.div`
  position: relative;
  height: 100vh;
  background: ${color.blue50};
`;

const Title = styled.h2`
  color: ${color.black2};
  ${font.h1_bold};
`;

const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  P.date {
    color: ${color.black};
    ${font.h4_bold};
  }

  p {
    color: ${color.opacityBlack05};
    ${font.body_regular};
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  gap: 64px;
`;
